module.exports = __webpack_public_path__ + "static/media/Combined_Shape__4_.2c64a2a2.svg";